/**
 * It's suggested to configure the RESTful endpoints in this file
 * so that there is only one source of truth, future update of endpoints
 * could be done from here without refactoring on multiple places throughout the app
 */

const rootAPI = process.env.REACT_APP_API_ENDPOINT;

const API = {
  auth: {
    login: `${rootAPI}/api/auth/login`,
    signUp: '/api/auth/register',
    user: `${rootAPI}/api/auth/users`,
  },
  generate_conversation: `${rootAPI}/api/conversations/generate`,
  audio: `${rootAPI}`,
  create_app: `${rootAPI}/api/app/create-app`,
  get_app_data: `${rootAPI}/api/app/get-app`,
  app_update: `${rootAPI}/api/app/update`,
  third_party_api: `${rootAPI}/api/third-party/connect`,
  access_control: `${rootAPI}/api/access-control/users`,
  instruction: `${rootAPI}/api/instruction`,
  fields: `${rootAPI}/api/fields`,
  images: `${rootAPI}/src/uploads/images`,
  messages: `${rootAPI}/api/conversations/messages`,
};

export { API, rootAPI };

